import { render, staticRenderFns } from "./PartyPage.vue?vue&type=template&id=b63543aa&"
import script from "./PartyPage.vue?vue&type=script&lang=js&"
export * from "./PartyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports